var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkInBio({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "url(#paint0_linear_link_in_bio)",
    strokeWidth: 2.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 3,
    width: 28,
    height: 42,
    rx: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 16.5,
    r: 6.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 14.8,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8 21.4C20.6 19.4 22.2 18.4 24 18.4C25.8 18.4 27.4 19.4 28.2 21.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 28H31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 33H31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 38H31"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "url(#paint0_linear_link_in_bio)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16.8,
    cy: 28,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.8,
    cy: 33,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.8,
    cy: 38,
    r: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_link_in_bio",
    x1: 24,
    y1: 3,
    x2: 24,
    y2: 45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85329A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#477CCA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkInBio);
export default __webpack_public_path__ + "static/media/link-in-bio.ea7c8fb55c09bb88a37a165a40420e1c.svg";
export { ForwardRef as ReactComponent };